import { Route, BrowserRouter as Router, Routes } from "react-router-dom";

import Error from "./pages/ResetPassword/Error";
import Home from "./pages/Home";
import Reauth from "./pages/Reauth";
import ResetPassword from "./pages/ResetPassword";
import ResetSuccess from "./pages/ResetPassword/ResetSuccess";
import Return from "./pages/Return";

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/reset-success" element={<ResetSuccess />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/error" element={<Error />} />
        <Route path="/return" element={<Return />} />
        <Route path="/reauth" element={<Reauth />} />
      </Routes>
    </Router>
  );
};

export default App;
